import { Skeleton } from "antd";

const Loading = () => {
  return <Skeleton />;
};

export default Loading;
